import React, { FC, useState, useEffect, ChangeEvent, useContext } from "react";
import Row from "antd/lib/row";
import Space from "antd/lib/space";
import Message from "antd/lib/message";
import { ReactComponent as CompanyIcon } from "../../icons/company.svg";
import { ReactComponent as ContactNameIcon } from "../../icons/contact_name.svg";
import { ReactComponent as EditIcon } from "../../icons/edit.svg";
import { ReactComponent as PhoneIcon } from "../../icons/phone.svg";
import { TypeCallerInfor } from "../../types/TypeContact";
import { addEditCallerAction, callerInforCompare } from "./action";
import { CallerInforContext } from "../../contexts/customerProfile";
import {
  StyledButtonContainer,
  StyledContent,
  StyledInput,
  StyledContainer,
  StyledHeader,
  StyledButton,
  StyledErrorMsg,
} from "./styledComponents";
import dialableNumber from "../../utils/dialableNumber";

const ContactInfor: FC<{
  caller: TypeCallerInfor;
  exsitingCaller: boolean;
}> = ({ caller, exsitingCaller }) => {
  const { callerInfor: existingCallerInfor, updateCallerInfor } = useContext(
    CallerInforContext
  );

  const [disabled, setDisabled] = useState<boolean>(false);
  const [callerInfor, setCallerInfor] = useState<TypeCallerInfor>({
    ...caller,
  });
  const [actionType, setActionType] = useState<string>("ADD");
  const [processing, setProcessing] = useState<boolean>(false);
  const [buttonDisabled, setButtonDisabled] = useState<boolean>(true);
  const [phoneValid, setPhoneValid] = useState<boolean>(true);

  const editFunction = () => {
    setActionType("EDIT");
    setDisabled(false);
  };

  const phoneValidator = (phone: string) => {
    const regEx = /^\+[1-9]\d{10,14}$/;
    return regEx.test(phone);
  };

  const onChange = (type: string) => (e: ChangeEvent<HTMLInputElement>) => {
    let validPhoneNumber = phoneValid;
    let value = e.target.value;
    if (type === "phoneNumber") {
      value = dialableNumber(value);
      validPhoneNumber = phoneValidator(value);
      setPhoneValid(validPhoneNumber);
    }
    callerInfor[type] = value;
    if (
      callerInfor.customerName.length < 1 ||
      callerInfor.phoneNumber.length < 1 ||
      !validPhoneNumber
    ) {
      setButtonDisabled(true);
    } else {
      setButtonDisabled(false);
    }
    setCallerInfor({ ...callerInfor });
  };

  const addEditCaller = async () => {
    let processAction = true;
    if (actionType === "EDIT") {
      processAction = callerInforCompare(existingCallerInfor, callerInfor);
    }
    if (processAction) {
      setProcessing(true);
      const result = await addEditCallerAction(
        actionType,
        callerInfor,
        existingCallerInfor.phoneNumber
      );
      if (result === 200) {
        setDisabled(true);
        Message.success(`${actionType} contact successful.`, 1);
        updateCallerInfor(callerInfor);
      } else {
        Message.error(`${actionType} contact failed.`, 1);
      }
      setProcessing(false);
    } else {
      setDisabled(true);
      Message.info("EDIT profile won't be performed since no data changed.");
    }
  };

  useEffect(() => {
    setDisabled(exsitingCaller);
    //Contact
    setCallerInfor({ ...caller });
    if (
      callerInfor.customerName.trim().length > 0 &&
      callerInfor.phoneNumber.trim().length > 0
    ) {
      setButtonDisabled(false);
    }
  }, [caller, exsitingCaller]);

  const style = { background: "#0092ff", padding: "8px 0" };

  return (
    <>
      <StyledContainer>
        <Row>
          <StyledHeader span={7}>Name</StyledHeader>
          <StyledHeader span={8}>Company</StyledHeader>
          <StyledHeader span={8}>Phone number</StyledHeader>
          <StyledHeader span={1} className="edit">
            {disabled ? <EditIcon onClick={editFunction} /> : null}
          </StyledHeader>
        </Row>
        <Row>
          <StyledContent span={7}>
            <Space>
              <ContactNameIcon />
              <StyledInput
                value={callerInfor?.customerName}
                disabled={disabled}
                onChange={onChange("customerName")}
                validationResult={true}
              />
            </Space>
          </StyledContent>
          <StyledContent span={8}>
            <Space>
              <CompanyIcon />
              <StyledInput
                value={callerInfor?.company}
                onChange={onChange("company")}
                disabled={disabled}
                className="updatedWidth"
                validationResult={true}
              />
            </Space>
          </StyledContent>
          <StyledContent span={8}>
            <Space>
              <PhoneIcon style={{ fontSize: "14px" }} />
              <StyledInput
                value={callerInfor?.phoneNumber}
                onChange={onChange("phoneNumber")}
                disabled={disabled}
                className="updatedWidth"
                validationResult={phoneValid}
              />
            </Space>
            {phoneValid ? null : (
              <StyledErrorMsg>
                Please input E.164 format phone number.
              </StyledErrorMsg>
            )}
          </StyledContent>
          <StyledContent span={1}></StyledContent>
        </Row>
      </StyledContainer>
      {!disabled ? (
        <Row style={{ maxWidth: "757px" }}>
          <StyledButtonContainer span={24}>
            <StyledButton
              onClick={addEditCaller}
              loading={processing}
              disabled={buttonDisabled}
            >
              {actionType === "ADD" ? "Add contact" : "Save"}
            </StyledButton>
          </StyledButtonContainer>
        </Row>
      ) : null}
    </>
  );
};

export default ContactInfor;
